export default __webpack_public_path__ + "static/media/i_verificaçoes_carro.e055919d.svg";